import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { translate } from 'react-i18next';

// Components
import ExtComp from '../external';

// Services
import { getTranslateDocSpecialties, getPractitionerName } from 'src/views/practitioner/services/appointments';
import { parseToValidPhone } from 'services/phoneNumber';
import { dateWithTimezone } from 'src/services/date';

// Style && Images
import s from './DrawerSection.style';
import { CamIcon, DoctorPhotoDefault, ClockIcon, UserPhotoDefault, LetterIcon, PhoneCallIcon } from '../svgIcons';


const DrawerSection = (props) => {
  const { appoint, showDrawer, triggerDrawer, t } = props;
  const dateTime = appoint && appoint.dateTime ? moment(appoint.dateTime).format('dddd DD.MM.YYYY') : null;
  const patient = appoint && appoint.patient;

  return (
    <s.InfoDrawer isOpen={showDrawer}>
      {/* ──── Caption ─────────────────────────────────────────────────────────────────────────── */}
      <h1 className="draw-title">
        {t('information')}
        <button className="close-button" onClick={triggerDrawer} title="Close">
          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14">
            <g fill="none" fillRule="evenodd">
              <path d="M0 0L24 0 24 24 0 24z" transform="translate(-5 -5)" />
              <path fill="#A2A4B2" fillRule="nonzero" d={`M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 
            10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z`} transform="translate(-5 -5)" />
            </g>
          </svg>
        </button>
      </h1>

      {/* ──── Appoint details ─────────────────────────────────────────────────────────────────── */}
      <div className="block">
        <h3 className="block-caption">Appointment details</h3>

        {/* Date & type m */}
        <div className="row-with-img">
          <div className="img-container">
            <ExtComp.ImageWithDefault defaultImg={CamIcon} />
          </div>
          <div className="right-section">
            <p className="title">{dateTime}</p>
            <p className="sub-title">Video consultation</p>
          </div>
        </div>

        {/* Doctor info */}
        <div className="row-with-img">
          <div className="img-container">
            <ExtComp.ImageWithDefault defaultImg={DoctorPhotoDefault} />
          </div>
          <div className="right-section">
            <p className="title">{appoint && getPractitionerName(appoint.practitioner)}</p>
            <p className="sub-title">{appoint && getTranslateDocSpecialties(appoint.practitioner)}</p>
          </div>
        </div>

        {/* Meet time */}
        <div className="row-with-img">
          <div className="img-container">
            <ExtComp.ImageWithDefault defaultImg={ClockIcon} />
          </div>
          <div className="right-section">
            <p className="sub-title">Scheduled time</p>
            <p className="title">
              {dateWithTimezone(appoint.dateTime)}
              <ExtComp.ArrivalDelay appointment={appoint} />
            </p>
          </div>
        </div>
      </div>

      {/* ──── Patient details ─────────────────────────────────────────────────────────────────── */}
      {patient ? <div className="block">
        <h3 className="block-caption">Patient details</h3>

        {/* Patient */}
        <div className="row-with-img special-for-patients">
          <div className="img-container">
            <ExtComp.ImageWithDefault
              alt="patient"
              defaultImg={UserPhotoDefault}
              image={patient.photo}
            />
          </div>
          <div className="right-section">
            <p className="title">
              <span className="last-name">{patient.lastName} </span>
              <span>{patient.firstName}</span>
            </p>
            <p className="sub-title">
              <span>
                {`${moment(patient.birthDate).format('DD.MM.YYYY')} | ${t(patient.gender ? `gender_${patient.gender.toLowerCase()}` : 'no_data')}`}
                {patient.isNew && <span className="new-user"> | {t('new')} </span>}
              </span>
              <a href="#">View Profile</a>
            </p>
          </div>
        </div>

        {/* Email */}
        <div className="row-with-img">
          <div className="img-container">
            <ExtComp.ImageWithDefault defaultImg={LetterIcon} />
          </div>
          <div className="right-section">
            <p className="sub-title">{t('email')}</p>
            <p className="title">{patient.email || t('no_data')} <span className="like-label"> | UMBI </span></p>
            <p className="title">{patient.umbi && patient.umbi.email || t('no_data')} <span className="like-label"> | UG </span></p>
          </div>
        </div>

        {/* Phone */}
        <div className="row-with-img">
          <div className="img-container">
            <ExtComp.ImageWithDefault defaultImg={PhoneCallIcon} />
          </div>
          <div className="right-section">
            <p className="sub-title">{t('mobile_phone')}</p>
            <p className="title">{patient.phone ? parseToValidPhone(patient.phone) : t('no_data')}<span className="like-label"> | UMBI </span></p>
            <p className="title">{patient.umbi && patient.umbi.phone ? parseToValidPhone(patient.umbi.phone) : t('no_data')}<span className="like-label"> | UG </span></p>
          </div>
        </div>

      </div>
        : null
      }


    </s.InfoDrawer>
  );
};
DrawerSection.propTypes = {
  appoint: PropTypes.shape(),
  showDrawer: PropTypes.bool,
  triggerDrawer: PropTypes.func,
};
DrawerSection.defaultProps = {
  appoint: null,
  showDrawer: null,
  triggerDrawer: null,
};


export default translate()(DrawerSection);
